import React, { ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';

import facebook from 'assets/images/facebook.svg';
import twitter from 'assets/images/twitter.svg';
import instagram from 'assets/images/instagram.svg';
import pinterest from 'assets/images/pinterest.svg';
import { makeFormFieldState } from 'components/common/form-utils/form';
import { Validators, validateForm } from 'components/common/form-utils/validators';
import { FormErrorMessage } from 'components/common/form-utils/form-elements';
import { Button } from 'components/common/Button';
import { Icon } from 'components/common/Icon';
import generateLocator from 'utils/generate-locator';
import { checkCircleIcon } from 'assets/icons';

const SubscribeForm = () => {
  const [isSubscribeSuccess, setIsSubscribeSuccess] = useState(false);
  const form = makeFormFieldState({
    email: { visibleName: 'Email', required: true, validations: [Validators.isEmail()] },
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubscribeSuccess(validateForm(form));
  };

  return <div className="flex flex-1 flex-col max-w-sm max-h-40">
    <span className="font-extrabold text-lg text-gray-700 uppercase mt-4 md:mt-0 mb-2">News & Updates</span>
    <div className="my-2 flex flex-col text-md">
      <form onSubmit={handleSubmit}>
        <div className="mx-auto pb-4 flex items-center">
          <span className='px-4 relative'>
            {isSubscribeSuccess && (
              <span className='absolute p-3 right-6 bottom-0.5'>
                <Icon src={checkCircleIcon} />
              </span>)}
            <input
              id="subscribe-email"
              type="text"
              aria-label="Subscribe for daily news and updates"
              placeholder="yourmail@domain.com"
              className="flex-1 appearance-none rounded shadow p-3 text-grey-dark mr-2 focus:outline-none"
              onChange={event => form.email.setValue(event.target.value)} value={form.email.value || ''} />
          </span>
          <Button grey id='subscribe-button' type='submit' className='p-3'>Join Us</Button>
        </div>
      </form>
      <FormErrorMessage>{form.email.error}</FormErrorMessage>
      {isSubscribeSuccess ? (
        <span id="subscribe-message" className="my-2 text-secondary max-w-s text-sm">
          Thanks, you are all set for the updates on promotions and coupons.
        </span>
      ) : (
        <span id="subscribe-message" className="my-2 max-w-s text-sm">
          Subscribe now to get updates on promotions and coupons.
        </span>)}
    </div>
  </div>;
};

const SocialNetworkLinks = () => {
  const SocialNetworkLink = ({ to, name, icon }: { to: string, name: string, icon: string }) =>
    <Link to={to} id={generateLocator('contact', name)} aria-label={`Link to ${name}`} className='mx-5'>
      <img
        src={icon}
        alt={`Link to ${name}`}
        title={`Jupiter Prime ${name}`} />
    </Link>;

  return <div className="flex flex-1 flex-col">
    <span
      className="my-2 font-extrabold text-lg text-gray-700 uppercase mt-4 md:mt-0 mb-2"
    >
      Social Networks
    </span>
    <div className="flex justify-between mt-6" id="footericons">
      <SocialNetworkLink name='Facebook' to='https://www.facebook.com/jupitertoys' icon={facebook} />
      <SocialNetworkLink name='Twitter' to='https://www.twitter.com/jupitertoys' icon={twitter} />
      <SocialNetworkLink name='Instagram' to='https://www.instagram.com/jupitertoys' icon={instagram} />
      <SocialNetworkLink name='Pinterest' to='https://www.pinterest.com/jupitertoys' icon={pinterest} />
    </div>
  </div>;
};

const Footer = (): ReactElement => (
  <footer className="footer">
    <div className="container mx-auto px-6 mt-8 sm:mt-8 sm:w-full sm:px-8 grid justify-items-center grid-cols-3 md:flex-row">
      <div className="flex flex-1 flex-col lg:text-left">
        <span id="company" className="font-extrabold text-lg text-gray-700 uppercase mt-4 md:mt-0 mb-2">Company</span>
        <div className="my-2 flex flex-col text-md ">
          <Link className="hover:text-secondary" id="company-about-us-link" to="/about" >About Us</Link>
          <Link className="hover:text-secondary" id="company-tnc-link" to="/terms-and-conditions" >Terms &amp; Conditions</Link>
          <Link className="hover:text-secondary" id="company-careers-link" to="/careers">Careers</Link>
        </div>
      </div>
      <SocialNetworkLinks />
      <SubscribeForm />
    </div>
    <div className="container mx-auto px-6">
      <div className="mt-2 border-t-2 border-gray-300 flex flex-col items-center">
        <div className="sm:w-2/3 text-center pt-2">
          <p id="copyright" className="text-sm text-secondary">
            &copy; Jupiter Prime - {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </div>
  </footer >
);

export default Footer;
